import * as serverApi from './server';

// Protocol CRUD
export const getProtocol = ({ protocolId, ...payload }) =>
  serverApi.get(`/protocols/${protocolId}`, payload);
export const getProtocols = (payload) => serverApi.get('/protocols', payload);
export const addProtocol = (payload) => serverApi.post('/protocols', payload);
export const deleteProtocol = ({ protocolId, ...payload }) =>
  serverApi.del(`/protocols/${protocolId}`, payload);
export const deleteProtocolNote = ({ protocolId, noteId, ...payload }) =>
  serverApi.del(`/protocols/${protocolId}/notes/${noteId}`, payload);
export const completeProtocol = ({ protocolId, ...payload }) =>
  serverApi.post(`/protocols/${protocolId}/consentforms`, payload);

// Treatment CRUD
export const getTreatment = ({ protocolId, treatmentId, ...payload }) =>
  serverApi.get(`/protocols/${protocolId}/treatments/${treatmentId}`, payload);
export const addTreatment = ({ protocolId, ...payload }) =>
  serverApi.post(`/protocols/${protocolId}/treatments`, payload);
export const deleteTreatment = ({ protocolId, treatmentId, ...payload }) =>
  serverApi.del(`/protocols/${protocolId}/treatments/${treatmentId}`, payload);
export const updateTreatment = ({ protocolId, treatmentId, ...payload }) =>
  serverApi.put(`/protocols/${protocolId}/treatments/${treatmentId}`, payload);

export const deleteTreatmentNote = ({ protocolId, treatmentId, noteId, ...payload }) =>
  serverApi.del(`/protocols/${protocolId}/treatments/${treatmentId}/notes/${noteId}`, payload);
